{
  "title": "Plinko",
  "subtitle": "Ball path is determined by the server, frontend renders the result",
  "connecting": "Connecting…",
  "connected": "Connected",
  "reconnecting": "Reconnecting…",
  "unauthorized": "Unauthorized",
  "authFailed": "Login failed",
  "retryLogin": "Retry Connection",
  "backLobby": "Lobby",
  "lobby": "Lobby",
  "balance": "Balance {{amount}}",
  "bet": "Amount",
  "half": "1/2",
  "max": "Max",
  "quickChips": "Quick chips",
  "close": "Close",
  "risk": "Risk",
  "riskLow": "Low",
  "riskMedium": "Medium",
  "riskHigh": "High",
  "waiting": "Waiting to drop",
  "dropping": "Ball in motion…",
  "oddsLoading": "Loading payout table…",
  "oddsLoadFailed": "The payout table for this risk level is unavailable",
  "retryOdds": "Reload Payout Table",
  "balanceRefreshFailed": "Round completed; balance is temporarily unavailable",
  "balanceOutcomeUnknown": "The wager result could not be confirmed. Refresh your balance before dropping another ball.",
  "retryBalance": "Refresh Balance",
  "refreshingBalance": "Refreshing Balance…",
  "drop": "Drop Ball",
  "slot": "Slot {{n}}",
  "resultWin": "Win",
  "resultLose": "Loss",
  "payout": "Payout {{amount}}",
  "betFailed": "Bet failed",
  "rules": "Rules",
  "rulesTitle": "How to Play Plinko",
  "rulesBody": "Select your bet and risk level (Low / Medium / High). Drop the ball onto the peg board to watch it bounce into multiplier slots at the bottom. Edge slots have higher payouts while center slots offer balanced returns.",
  "errors": {
    "insufficient_funds": "Insufficient funds",
    "user_not_found": "User not found",
    "invalid_bet": "Invalid bet amount",
    "invalid_risk": "Invalid risk level",
    "unauthorized": "Please log in",
    "play_failed": "Game failed",
    "unknown": "An error occurred"
  }
}
